import { Module } from 'vuex';
import { ImportState } from './types'
import { RootState } from '../types'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const state: ImportState = {
  exam: {endpoints: {}},
  body: "",
  questions: [],
  uploaded: false
}

export const store: Module<ImportState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
